// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__276TR","modalForm":"UpgradeEpcsModal_modalForm__3XkOK","modalFooter":"UpgradeEpcsModal_modalFooter__7gFuE"};